/**
 * 根路径的落地判断
 * 只负责跳转，判断规则集中在 app/entry.ts，两处不要各写一份。
 */
import { Navigate } from 'react-router-dom';
import { resolveHomePath } from '@/app/entry';
import { useAuth } from '@/lib/auth/use-auth';

export function HomeRedirect() {
  const { user, can } = useAuth();
  if (user?.passwordChangeRequired) {
    return <Navigate to="/change-password" replace />;
  }
  // can 只在服务端没返回 defaultEntry 时兜底用，见 entry.ts 的说明
  return <Navigate to={resolveHomePath(user?.defaultEntry, can)} replace />;
}
